import React, { ReactNode } from 'react';
import colors from 'styles/themes/colors';
import Box from 'components/elements/Box';
import H1 from 'components/elements/h1';
import Span from 'components/elements/span';
import { ReactComponent as Close } from 'icons/icon-close.svg';
import { ModalCloseButton } from '../shared/styles';

interface IContainerProps {
  close?: () => void;
  title: string;
  subtitle?: string;
  children: ReactNode;
}

const ViewContainer: React.FC<IContainerProps> = ({
  title,
  subtitle,
  close,
  children,
}) => {
  return (
    <Box m={0} p={0} pt={1} pb={1}>
      <Box
        display="flex"
        justifyContent="flex-start"
        alignContent="stretch"
        alignItems="flex-end"
        borderBottom={`1px solid ${colors.LightGrey}`}
      >
        <Box ml={5} mt={2} mb={2}>
          <H1 fontSize={4}>{title}</H1>
          {subtitle && (
            <Span fontSize={1} color={colors.NotificationOrange}>
              {subtitle}
            </Span>
          )}
        </Box>
        {close && (
          <ModalCloseButton
            onClick={close}
            alignSelf="flex-start"
            marginLeft="auto"
            marginTop="2em"
          >
            <Close />
          </ModalCloseButton>
        )}
      </Box>
      {children}
    </Box>
  );
};

export default ViewContainer;
